export default "__VITE_ASSET__DsB0ybG7__"